/** Angular */
import { HttpParams, HttpParamsOptions } from '@angular/common/http';
/** Modules */
import { BydHttpUrlEncodingCodec } from './byd-http-params-encoder';
/**
 * An HTTP request/response body that represents serialized parameters,
 * per the MIME type `application/x-www-form-urlencoded`.
 *
 * This class extends HttpParams.
 */
export class BydHttpParams extends HttpParams {
  static encoder = new BydHttpUrlEncodingCodec();

  /**
   * Creates an instance of BydHttpParams.
   *
   * @param options the HttpParams options `BydHttpParamsOptions`.
   */
  constructor(options: HttpParamsOptions = {}) {
    super({ encoder: BydHttpParams.encoder, ...options });
  }
}
